import { Injectable } from "@angular/core";
import { VNavItemComponent } from "@directives/_core/v-nav-bar/v-nav-item/v-nav-item.component";
import { Subject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class VNavBarService {
    navItemChanged = new Subject<VNavItemComponent>()

    constructor() { }

    navItemChange(item: VNavItemComponent) {
        this.navItemChanged.next(item);
    }
}
